
/**
 * Classe resposável em manter as autorizações do usuário.
 */
export class AutorizacoesCanaDTO {

    cdAplicat: string;
    cdObjform: string;
    cdObjchild: string;
    cdGrupo: string;
    cdAcao: string;
    menuPath: string;

    constructor() { }
}